import { motion } from "framer-motion";

// Simple scroll-reveal wrapper: fade + slight rise when it enters the viewport.
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);

export default Reveal;
